'use strict';

var React = require('react');

var SvgPageReferenceMinor = function SvgPageReferenceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.172 2h-4.172a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3v-3a6.002 6.002 0 0 1 5-5.917v-3.255a2 2 0 0 0-.586-1.414l-1.828-1.828a2 2 0 0 0-1.414-.586Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.207 8.793a1 1 0 1 0-1.414 1.414l.793.793h-1.586c-2.21 0-4 1.535-4 3.429v2.714c0 .473.448.857 1 .857s1-.384 1-.857v-2.714c0-.947.895-1.429 2-1.429h1.586l-.793.793a1 1 0 0 0 1.414 1.414l2.5-2.5a1 1 0 0 0 0-1.414l-2.5-2.5Z"
  }));
};

exports.SvgPageReferenceMinor = SvgPageReferenceMinor;
